/**
 * @description 锚点，页面位置
 * @author wangfupeng
 */

export default function (eventData = {}) {
    const refedId = eventData.refedId
    if (!refedId) {
        console.error('弹框组件 id 未找到', refedId)
        return
    }

    const href = window.location.href
    const hrefWithoutHash = href.split('#')[0]
    const newHref = `${hrefWithoutHash}#${refedId}` // 拼接锚点 id
    window.location.href = newHref
}
